import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './components/app/App';
import './components/app/style.scss';

const root = createRoot(document.getElementById('root'));
root.render(
  <div>
    <App />
  </div>
);
